import { AuthenticityTokenInput } from "remix-utils/csrf/react";

export function CSRFToken() {
  return <AuthenticityTokenInput />;
}
